const recordAdjustment = {
  // 获取 glTrans 列表
  getGlTransList: "/recordAdjustment/glTrans/show",
  // 新增
  getAddRentGlTran: "/recordAdjustment/glTrans/addRentGlTran",
  // Void Check：查询、作废及重新开票
  getShowGlTrans: "/recordAdjustment/voidCheck/showGlTrans",
  getVoidCheckSubmit: "/recordAdjustment/voidCheck/voidCheck",
  getVoidCheckReissue: "/recordAdjustment/voidCheck/reissueVoidCheck",
  getVoidCheckHistory: "/recordAdjustment/voidCheck/showVoidCheckHistory",
  getVoidedCheckReissue: "/recordAdjustment/voidCheck/reissueVoidedCheck",
  // journalEntry 数据提交
  getJournalEntry: "/recordAdjustment/journalEntry/journalEntry",
  // journalEntry 文件上传提交
  getJournalEntryUpload: "/recordAdjustment/journalEntry/uploadJournalEntry",
  // debit Expense 提交
  getDebitExpenseSave: "/recordAdjustment/debitExpenseTransaction/save",
  // debit Expense 上传
  getDebitExpenseUpload: "/recordAdjustment/debitExpenseTransaction/upload",
};

export default recordAdjustment;
